/* LEKKA search bar: typewriter hints, product type scope, empty submit searches the shown hint. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(form) {
    if (!form || form.__lk) return;
    form.__lk = true;
    var wrap = form.closest('.lk-search');
    var input = form.querySelector('.lk-search__input');
    var select = form.querySelector('.lk-search__select');
    var out = form.querySelector('.lk-search__hint-text');
    var hints = [];
    try { hints = JSON.parse(form.querySelector('.lk-search__hints').textContent) || []; } catch (e) {}
    hints = hints.filter(function (h) { return h && String(h).trim(); });

    var idx = 0, pos = 0, deleting = false, timer = null, current = hints[0] || '';

    function setValueState() { wrap.classList.toggle('has-value', !!input.value); }
    input.addEventListener('input', setValueState);
    setValueState();

    function tick() {
      if (!hints.length) return;
      var word = hints[idx];
      current = word;
      if (reduce.matches) {
        out.textContent = '“' + word + '”';
        idx = (idx + 1) % hints.length;
        timer = setTimeout(tick, 3200);
        return;
      }
      if (!deleting) {
        pos++;
        out.textContent = '“' + word.slice(0, pos) + (pos >= word.length ? '”' : '');
        if (pos >= word.length) { deleting = true; timer = setTimeout(tick, 1800); return; }
        timer = setTimeout(tick, 55 + Math.random() * 60);
      } else {
        pos--;
        out.textContent = pos > 0 ? '“' + word.slice(0, pos) : '';
        if (pos <= 0) { deleting = false; idx = (idx + 1) % hints.length; timer = setTimeout(tick, 350); return; }
        timer = setTimeout(tick, 28);
      }
    }

    function start() { if (!timer && hints.length) tick(); }
    function stop() { clearTimeout(timer); timer = null; }

    if (hints.length) {
      wrap.classList.add('is-live');
      start();
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }).observe(form);
      }
    }

    // Right arrow on an empty field fills in the hint being shown
    input.addEventListener('keydown', function (e) {
      if (!input.value && current && e.key === 'ArrowRight') {
        e.preventDefault();
        input.value = current;
        setValueState();
      }
    });

    form.addEventListener('submit', function (e) {
      var term = input.value.trim();
      if (!term && current) term = current;
      var type = select ? select.value : '';
      var q = type ? (term ? term + ' ' : '') + 'product_type:"' + type + '"' : term;
      if (!q) { e.preventDefault(); input.focus(); return; }
      e.preventDefault();
      var url = form.getAttribute('action') + '?type=product&q=' + encodeURIComponent(q) + (type ? '' : '&options%5Bprefix%5D=last');
      window.location.href = url;
    });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-lk-search]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
